import { AxiosResponse } from 'axios';
import { axios } from '@repository/RequestClient';
import PhsEventApplyRq from '@domain/rq/phs/event/PhsEventApplyRq';
import PHSApplyRs from '@domain/rs/phs/apply/PhsApplyRs';
import PhsEventApplyStatusRs from '@domain/rs/phs/event/PhsEventApplyStatusRs';
import { PositionApplicationStatusRs } from '@domain/rs/phs/event/PositionApplicationStatusRs';

export default interface PHSEventRepo {
  //이벤트 응시 정보 생성 API
  fetchPHSEventApply(rq: PhsEventApplyRq): Promise<AxiosResponse<PHSApplyRs>>;

  //이벤트 응시 상태 조회 API
  fetchPHSApplyStatus(): Promise<AxiosResponse<PhsEventApplyStatusRs>>;

  //이벤트 포지션 지원 상태 조회
  fetchPositionApplicationStatus(): Promise<AxiosResponse<PositionApplicationStatusRs>>;
}

export class RemotePHSEventRepo implements PHSEventRepo {
  fetchPHSEventApply(rq: PhsEventApplyRq): Promise<AxiosResponse<PHSApplyRs>> {
    return axios.post('/phs/event/apply', {
      ...rq,
    });
  }

  fetchPHSApplyStatus(): Promise<AxiosResponse<PhsEventApplyStatusRs>> {
    return axios.get('/phs/event/apply/status');
  }

  fetchPositionApplicationStatus(): Promise<AxiosResponse<PositionApplicationStatusRs>> {
    return axios.get('/phs/event/position/application');
  }
}
